fourToldApp.controller("tokenVerificationCntrl", function($scope, esb, services, $window, $routeParams, $location, $mdToast, $mdDialog, theme, $q) {
  $scope.aditional = new Object();
  $scope.theme = theme.getTheme();
  
  $scope.cancel = function(){
    $location.path("/");
  }
  
  $scope.next = function(){
    $location.path("/password-recovery");
  }
  
});
